import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { listStatementRuns } from "@/lib/invoices-payments";
import { BulkRunStatusBadge } from "@/components/invoices-payments";
import { Button } from "@/components/ui/button";

export default function StatementRunsListPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["statement-runs"],
    queryFn: () => listStatementRuns({ pageSize: 50 }),
    retry: false,
  });

  return (
    <div className="p-6" data-testid="statement-runs-list">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Statement runs</h1>
        <Button asChild><Link to="/statements/runs/new">New statement run</Link></Button>
      </div>
      {isLoading && <div role="status">Loading runs…</div>}
      {isError && <div role="alert" className="text-red-600">Could not load runs. Retry?</div>}
      {data && data.items.length === 0 && (
        <div className="rounded-md border p-8 text-center text-slate-500">
          No statement runs yet. Click <em>New statement run</em> to start one.
        </div>
      )}
      {data && data.items.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">Started</th>
              <th>Completed</th>
              <th>Requested by</th>
              <th>Mode</th>
              <th>Accounts</th>
              <th>OK / Fail</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.items.map(r => (
              <tr key={r.runId} className="border-t hover:bg-slate-50">
                <td className="py-2">{new Date(r.startedAtUtc).toLocaleString()}</td>
                <td>{r.completedAtUtc ? new Date(r.completedAtUtc).toLocaleString() : "—"}</td>
                <td>{r.requestedByUserId}{r.isRecurring && <span className="ml-1 text-xs text-slate-400">(auto)</span>}</td>
                <td>{r.deliveryMode}</td>
                <td>{r.accountCount}</td>
                <td>{r.successCount} / {r.failureCount}</td>
                <td><BulkRunStatusBadge status={r.status} /></td>
                <td><Link to={`/statements/runs/${r.runId}`} className="text-blue-600 hover:underline">Open</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
